import React, { useState } from "react";

const BoardOfDirectors = (props) => {
    const [directors, setDirectors] = useState([
        // { id: 1, name: "", designation: "", isEditing: true },
        // { id: 2, name: "John Tan", designation: "Director", isEditing: false },
        // { id: 3, name: "Pankaj Chauhan", designation: "Team Leader", isEditing: false },
    ]);

    // const handleEditClick = (id) => {
    //     
    //     setDirectors(
    //         directors.map((director) =>
    //             director.id === id
    //                 ? { ...director, isEditing: !director.isEditing }
    //                 : director
    //         )
    //     );
    //     console.log("dfsgdfg", directors);
    // };

    // const handleChange = (id, field, value) => {
    //     setDirectors(
    //         directors.map((director) =>
    //             director.id === id ? { ...director, [field]: value } : director
    //         )
    //     );
    // };

    // const handleAdd = () => {
    //     
    //     const newId = directors.length ? directors[directors.length - 1].id + 1 : 1;
    //     setDirectors([
    //         ...directors,
    //         { id: newId, name: "", designation: "", isEditing: true },
    //     ]);
    // };

    // const handleDelete = (id) => {
    //     setDirectors(directors.filter((director) => director.id !== id));
    // };
    return (
        <>
            {
                props.boardDirectorList != null ?

                    <div className="board-of-directors ">
                        <table className="border border-[#11378a] w-full  ">
                            <tr className="bg-[#11378a] border border-[#11378a] text-white text-xl font-bold ">
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Name
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Designation
                                </th>
                            </tr>
                            <>
                                {
                                    props.boardDirectorList.map((value, key) => {
                                        return (
                                            <React.Fragment key={key}>
                                                <tbody>
                                                    <tr className="border border-[#11378a]">
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.name}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.designation}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </React.Fragment >
                                        )
                                    }
                                    )
                                }
                            </>
                        </table>
                    </div>
                    : null
            }
            {
                props.topManagementList != null ?
                    <div className="board-of-directors ">
                        <table className="border border-[#11378a] w-full  ">
                            <tr className="bg-[#11378a] border border-[#11378a] text-white text-xl font-bold ">
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Name
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Designation
                                </th>
                            </tr>
                            <>
                                {
                                    props.topManagementList.map((value, key) => {
                                        return (
                                            <React.Fragment key={key}>
                                                <tbody>
                                                    <tr className="border border-[#11378a]">
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.name}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.designation}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </React.Fragment >
                                        )
                                    }
                                    )
                                }
                            </>
                        </table>
                    </div>
                    : null
            }


        </>
    );
};

export default BoardOfDirectors;